import { MutationTree } from "vuex";
import { IProvidersUsersState, getDefaultProvidersUsersState } from ".";
import { IProvidersUser } from "@/models/providers-user";

export const mutations: MutationTree<IProvidersUsersState> = {
    setScopedUsers(state, payload: IProvidersUser[]) {
        state.scopedUsersError = null;
        state.usersScopedList = [...payload];
    },
    setScopedCPUsers(state, payload: IProvidersUser[]) {
        state.scopedUsersError = null;
        state.usersScopedCPList = [...payload];
    },
    setUnscopedUsers(state, payload: IProvidersUser[]) {
        state.unscopedUsersError = null;
        state.usersUnscopedList = [...payload];
    },
    setSelectedProvidersUser(state, payload: IProvidersUser) {
        state.isSelectedProvidersUser = !!payload;
        state.selectedProvidersUser = payload;
    },
    setScopedUsersError(state, payload: any) {
        state.scopedUsersError = payload;
    },
    setUnscopedUsersError(state, payload: any) {
        state.unscopedUsersError = payload;
    },
    resetState(state) {
        Object.assign(state, getDefaultProvidersUsersState());
    },
};
